import { get, hasIn, isArray, isEmpty, isFunction, isString } from 'lodash'

import locales from '../locales'

const VIEW_MOBILE = 'mobile'
const VIEW_DESKTOP = 'desktop'

const stringFormat = (string, params) => {
  const search = /\{([\s\S]+?)\}/g
  params = params || {}

  if (isString(string)) {
    return string.replace('\\n', '\n').replace(search, function (term) {
      let key = term.substring(1).slice(0, -1)
      return params[key] !== undefined ? params[key] : term
    })
  }
  return string
}

const labelFormat = (label, replacements) => {
  if (isArray(label)) {
    return label.map(l => {
      return stringFormat(l, replacements)
    })
  }
  return stringFormat(label, replacements)
}

class MedicalOffice {
  constructor(options = {}) {
    this.imagePath = options.imagePath
    this.callbacks = {}
    this.labels = locales
    this.viewPort = VIEW_DESKTOP

    if (!isEmpty(options)) {
      this.setOptions(options)
    }
  }

  setOptions(options) {
    this.callbacks = options.callbacks || {}
    this.setLabels(options.labels)
    this.setViewPort(options.viewPort)
  }

  setLabels(labels) {
    this.labels = labels || locales
  }

  setViewPort(port) {
    this.viewPort = port || VIEW_DESKTOP
  }

  isMobile() {
    return this.viewPort === VIEW_MOBILE
  }

  isDesktop() {
    return this.viewPort === VIEW_DESKTOP
  }

  findProviders(payload) {
    if (!hasIn(this, 'callbacks.findProviders') || !isFunction(this.callbacks.findProviders)) {
      console.error(new Error("Can't found callback: findProviders"))
    }
    return this.callbacks.findProviders(payload)
  }

  getLocations(payload) {
    if (!hasIn(this, 'callbacks.getLocations') || !isFunction(this.callbacks.getLocations)) {
      console.error(new Error("Can't found callback: getLocations"))
    }
    return this.callbacks.getLocations(payload)
  }

  getProduct(payload) {
    if (hasIn(this, 'callbacks.getProduct') && isFunction(this.callbacks.getProduct)) {
      return this.callbacks.getProduct(payload)
    }
  }

  hasLabel(id) {
    return hasIn(this.labels, id)
  }

  $t(id, replacements) {
    if (this.hasLabel(id)) {
      const label = get(this.labels, id, '')
      return labelFormat(label, replacements)
    } else if (id && process.env.NODE_ENV === 'development') {
      return id
    }
    return ''
  }
}

export default MedicalOffice
